import { render } from "./DCatalogueItemCreateEditDialog.vue?vue&type=template&id=a4815ee8&scoped=true&ts=true"
import script from "./DCatalogueItemCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./DCatalogueItemCreateEditDialog.vue?vue&type=script&lang=ts"

import "./DCatalogueItemCreateEditDialog.vue?vue&type=style&index=0&id=a4815ee8&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4815ee8"]])

export default __exports__